import { Widget } from './Widget';
import { render } from 'preact';
import { logger } from './utils/logger';
import { ConfigContext } from './ConfigContext';
import widget_css from './Widget.css?raw';

declare global {
  interface Window {
    ShopifyAnalytics: any;

    lightlabs: {
      debug: boolean;
      logs: { message: string; args: any[] }[];
    };
  }
}

window.lightlabs ||= {
  debug: false,
  logs: [],
};

const DEFAULT_API_URL = 'https://app.lightlabs.com';

class LightLabsWidget extends HTMLElement {
  constructor() {
    super();
  }

  getAndLogAttribute(name: string) {
    const value = this.getAttribute(name);
    logger.log(name, value);

    return value;
  }

  connectedCallback() {
    window.lightlabs.debug ||= !!this.getAndLogAttribute('debug');

    const companyId = this.getAndLogAttribute('company-id');
    if (!companyId) return;

    const apiUrl = this.getAndLogAttribute('api-url') || DEFAULT_API_URL;

    const root = this.attachShadow({ mode: 'open' });

    const style = document.createElement('style');
    style.textContent = widget_css;
    root.appendChild(style);

    render(
      <ConfigContext.Provider value={{ companyId, apiUrl }}>
        <Widget />
      </ConfigContext.Provider>,
      root,
    );
  }
}

customElements.define('lightlabs-widget', LightLabsWidget);

console.log('light-labs v5 | Initialized');
